<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">

    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Representante Legal
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
            Ante cualquier duda, comuníquese con su promotor.
          </p>  
        </md-card-content> 
      </md-card>   

      <md-card class="md-elevation-0 m-5"  :class="getValidationClass('rptelegal')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          ¿Tiene usted un representante legal? *
        </md-card-header>
        <md-card-content>
          
          <div>
            
            <div>
              <md-checkbox v-model="form.rptelegal" value="Si">Sí</md-checkbox>
              <md-checkbox v-model="form.rptelegal" value="No">No</md-checkbox>
            </div>

            <div class="radioform" :class="getValidationClass('rptelegal')">
              <span class="md-error" v-if="!$v.form.rptelegal.required">Esta respuesta es obligatoria.</span>
            </div>            

          </div>
        </md-card-content> 
      </md-card>         

      <div>
        <md-button class="md-raised" @click="back">Atras</md-button>  
        <md-button class="md-raised" type="submit">Siguiente</md-button>  
      </div>                   


    </div>
  </form>
</template>

<style>

</style>

<script>
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  name: 'Form22',
  data: () => ({
    form:{
      rptelegal: null,
    }
  }),
  mounted: function(){
    this.form = this.$store.state.form.form22
  },  
  validations: {
    form: {
      rptelegal: {
        required,
      },
    },
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.form.for22
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var index = "0"
        if(this.form.rptelegal == "Si"){
          index = "23"
        }else{
          index = "4"
        }
        this.$emit('setSaveForm', {id:"22", form: this.form, index: index});

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },        
  }      
}
</script>
